<div class="card-body text-center">
	<table class="table theme-main-color">
		<thead class="table-light theme-main-color">
			<tr>
				<th scope="col ">
					{{
						isReportByBeneficiaire
							? labelBeneficiaireCapitalized
							: labelIntervenantCapitalized
					}}
				</th>
				<th scope="col">
					{{ labelInterventionCapitalizedPluralized }}
				</th>
				<!--<th scope="col" *ngIf="!isReportByBeneficiaire">Réunions</th>-->
				<th scope="col" *ngIf="!isReportByBeneficiaire">Distance (km)</th>
				<th scope="col">Temps de face à face (h)</th>
				<th scope="col" *ngIf="!isReportByBeneficiaire && isSESSAD">
					Temps missions annexes (h)
				</th>
				<th scope="col" *ngIf="!isReportByBeneficiaire">Temps de trajet (h)</th>
				<th scope="col" *ngIf="!isReportByBeneficiaire && isSESSAD">
					Temps administratif et de préparation (h)
				</th>
				<!-- <th scope="col" *ngIf="!isReportByBeneficiaire">Temps réunion (h)</th> -->
				<th scope="col" *ngIf="!isReportByBeneficiaire">Temps total (h)</th>
			</tr>
		</thead>
		<tbody *ngFor="let employee of statsEmployee; let i = index">
			<tr
				*ngIf="
					statsEmployee[i].competence?.includes(mapCompetence[categorie]) &&
					statsEmployee[i].fullName !== 'Total'
				"
			>
				<th scope="row">
					{{ statsEmployee[i].fullName
					}}<span *ngIf="isSESSAD">({{ statsEmployee[i].competence }})</span>
				</th>
				<td>{{ statsEmployee[i].numberFormation }}</td>
				<!--<td *ngIf="!isReportByBeneficiaire">
					{{ statsEmployee[i].numberReunion }}
				</td>-->
				<td *ngIf="!isReportByBeneficiaire">
					{{ statsEmployee[i].distanceParcourue / 1000 | number: '1.2-2' }}
					Km
				</td>
				<td>
					{{ dateUtils.timeConvert(statsEmployee[i].tempsFaceAFace) }}
				</td>
				<td *ngIf="!isReportByBeneficiaire && isSESSAD">
					{{ dateUtils.timeConvert(statsEmployee[i].tempsMissionsAnnexes) }}
				</td>
				<td *ngIf="!isReportByBeneficiaire">
					{{ dateUtils.timeConvert(statsEmployee[i].tempsTrajet) }}
				</td>
				<td *ngIf="!isReportByBeneficiaire && isSESSAD">
					{{
						dateUtils.timeConvert(
							statsEmployee[i].tempsAdministratifAndPreparation
						)
					}}
				</td>
				<!-- <td *ngIf="!isReportByBeneficiaire">
					{{ dateUtils.timeConvert(statsEmployee[i].tempsReunion) }}
				</td> -->
				<td *ngIf="!isReportByBeneficiaire">
					{{ dateUtils.timeConvert(statsEmployee[i].tempsTravailTotal) }}
				</td>
			</tr>
			<tr
				*ngIf="
					mapCompetence[categorie] === 'Global' &&
					statsEmployee[i].fullName !== 'Total'
				"
			>
				<th scope="row">
					{{ statsEmployee[i].fullName
					}}<span *ngIf="isSESSAD">({{ statsEmployee[i].competence }})</span>
				</th>
				<td>{{ statsEmployee[i].numberFormation }}</td>
				<!-- <td *ngIf="!isReportByBeneficiaire">
					{{ statsEmployee[i].numberReunion }}
				</td> -->
				<td *ngIf="!isReportByBeneficiaire">
					{{ statsEmployee[i].distanceParcourue / 1000 | number: '1.2-2' }}
					Km
				</td>
				<td>
					{{ dateUtils.timeConvert(statsEmployee[i].tempsFaceAFace) }}
				</td>
				<td *ngIf="!isReportByBeneficiaire && isSESSAD">
					{{ dateUtils.timeConvert(statsEmployee[i].tempsMissionsAnnexes) }}
				</td>
				<td *ngIf="!isReportByBeneficiaire">
					{{ dateUtils.timeConvert(statsEmployee[i].tempsTrajet) }}
				</td>
				<td *ngIf="!isReportByBeneficiaire && isSESSAD">
					{{
						dateUtils.timeConvert(
							statsEmployee[i].tempsAdministratifAndPreparation
						)
					}}
				</td>
				<!-- <td *ngIf="!isReportByBeneficiaire">
					{{ dateUtils.timeConvert(statsEmployee[i].tempsReunion) }}
				</td> -->
				<td *ngIf="!isReportByBeneficiaire">
					{{ dateUtils.timeConvert(statsEmployee[i].tempsTravailTotal) }}
				</td>
			</tr>
			<tr
				class="bg-secondary text-white"
				*ngIf="
					(statsEmployee[i].competence === mapCompetence[categorie] &&
						statsEmployee[i].fullName === 'Total' &&
						statsEmployee[i].competence !== 'Global') ||
					(mapCompetence[categorie] === 'Global' &&
						statsEmployee[i].competence === 'Global')
				"
			>
				<th scope="col">
					{{ statsEmployee[i].fullName
					}}<span *ngIf="isSESSAD">({{ statsEmployee[i].competence }})</span>
				</th>
				<th scope="col">{{ statsEmployee[i].numberFormation }}</th>
				<!-- <th scope="col" *ngIf="!isReportByBeneficiaire">
					{{ statsEmployee[i].numberReunion }}
				</th> -->
				<th scope="col" *ngIf="!isReportByBeneficiaire">
					{{ statsEmployee[i].distanceParcourue / 1000 | number: '1.2-2' }}
					Km
				</th>
				<th scope="col">
					{{ dateUtils.timeConvert(statsEmployee[i].tempsFaceAFace) }}
				</th>
				<th scope="col" *ngIf="!isReportByBeneficiaire && isSESSAD">
					{{ dateUtils.timeConvert(statsEmployee[i].tempsMissionsAnnexes) }}
				</th>
				<th scope="col" *ngIf="!isReportByBeneficiaire">
					{{ dateUtils.timeConvert(statsEmployee[i].tempsTrajet) }}
				</th>
				<th scope="col" *ngIf="!isReportByBeneficiaire && isSESSAD">
					{{
						dateUtils.timeConvert(
							statsEmployee[i].tempsAdministratifAndPreparation
						)
					}}
				</th>
				<!-- <th scope="col" *ngIf="!isReportByBeneficiaire">
					{{ dateUtils.timeConvert(statsEmployee[i].tempsReunion) }}
				</th> -->
				<th scope="col" *ngIf="!isReportByBeneficiaire">
					{{ dateUtils.timeConvert(statsEmployee[i].tempsTravailTotal) }}
				</th>
			</tr>
		</tbody>
	</table>
</div>
